export const BPNS_REGEX = /^BPNS[0-9A-Z]{12}$/;

export const COMPANY_WIDE_VALUE = '__company_wide__';

export const BPNS_GUIDE_PDF_URL = `${process.env.REACT_APP_S3_CONTENT_URL}/media/PACIFIC_Add_Sites_Guide.pdf`;
